export const getCategoryThumbnailUrl = (category) => {
  if (category.videoPreviewUrl && category.videoPreviewUrl !== "") {
    return category.videoPreviewUrl;
  } else if (category.imageUrl && category.videoPreviewUrl !== "") {
    return category.imageUrl;
  } else if (category.physioImage && category.physioImage !== "") {
    return category.physioImage;
  } else if (category.youtubeVideo) {
    return (
      "http://img.youtube.com/vi/" +
      category.youtubeVideo.id +
      "/maxresdefault.jpg"
    );
  } else if (category.videoUrl && category.videoUrl !== "") {
    return category.videoUrl;
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/components/utils/CategoryUtils.js